import React, {createContext, ReactNode, useContext, useEffect, useState} from 'react';
import {eventEmitter} from "../helpers/eventEmitter";

interface Alert {
    message: string;
    severity: 'error' | 'warning' | 'info' | 'success';
}

interface AlertContextProps {
    error: string | null;
    info: string | null;
    alert: Alert | null;
    setAlert: (alert: Alert | null) => void;
    setError: (text: string) => void;
    setInfo: (text: string) => void;
}

const AlertContext = createContext<AlertContextProps>({
    error: null,
    info: null,
    alert: null,
    setAlert: () => {
    },
    setError: () => {
    },
    setInfo: () => {
    },
});

export const useAlert = () => useContext(AlertContext);

interface AlertProviderProps {
    children: ReactNode;
}

export const AlertProvider: React.FC<AlertProviderProps> = ({children}) => {
    const [alert, setAlert] = useState<Alert | null>(null);
    const [error, setErrorText] = useState<string>('');
    const [info, setInfoText] = useState<string>('');

    useEffect(() => {
        const handleAlert = (payload: Alert) => {
            setAlert(payload);
        };

        eventEmitter.on('alert', handleAlert);

        return () => {
            eventEmitter.off('alert', handleAlert);
        };
    }, []);

    const setError = (text: string) => {
        setAlert({
            severity: "error",
            message: text
        })
    }

    const setInfo = (text: string) => {
        setAlert({
            severity: "info",
            message: text
        })
    }


    return (
        <AlertContext.Provider value={{alert, error, info, setAlert, setError, setInfo}}>
            {children}
        </AlertContext.Provider>
    );
};